import { Injectable } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class StaticResourceService {
  private ResultMap = new Map<string, SafeUrl>();

  constructor(private sanitizer: DomSanitizer) {}

  async load(url: string, cb: (result: SafeUrl | "") => void = () => {}) {
    if (!url || typeof url !== "string") {
      cb("");
      return "";
    }
    if (this.ResultMap.has(url)) {
      const result = this.ResultMap.get(url) || "";
      cb(result);
      return result;
    }

    const res = await fetch(url);
    if (!res.ok) {
      cb("");
      return "";
    }

    const blob = await res.blob();
    return new Promise<SafeUrl | "">((resolve) => {
      const reader = new FileReader();
      const callback = (result: string) => {
        const safeUrl = this.sanitizer.bypassSecurityTrustUrl(result);
        if (safeUrl) {
          this.ResultMap.set(url, safeUrl);
        }
        resolve(safeUrl);
        cb(safeUrl);
      };

      reader.onloadend = () => callback(reader.result as string);
      reader.onerror = () => callback("");
      reader.readAsDataURL(blob);
    });
  }

  async forceLoad(url: string, cb: (result: SafeUrl | "") => void) {
    while (true) {
      const result = await this.load(url);
      if (result) {
        cb(result);
        return result;
      }
      await new Promise((resolve) => setTimeout(resolve, 2000));
    }
  }
}
